import { PayslipFirmComponent } from './../payslip-firm/payslip-firm.component';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { ViewEmployeeVoicePage } from 'src/app/modules/employee-voice/view-employee-voice/view-employee-voice.page';
import { ReceiveRecognizeComponent } from 'src/app/modules/recognize-team/modals/receive-recognize/receive-recognize.component';
import { RecognizeByPage } from 'src/app/modules/recognize-team/recognize-by/recognize-by.page';
import { PushService } from 'src/app/services/push.service';
import { RecognizeService } from 'src/app/services/recognize.service';
import { SurveyService } from 'src/app/services/survey.service';
import { PreviewAnyFile } from '@ionic-native/preview-any-file/ngx';
import { PayrollAdvanceService } from '../../../services/payroll-advance.service';
import { SuaLetterService } from '../../../services/sua-letter.service';
import { ToastController } from "@ionic/angular";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notifications-home-modal',
  templateUrl: './notifications-home-modal.component.html',
  styleUrls: ['./notifications-home-modal.component.scss'],
})
export class NotificationsHomeModalComponent implements OnInit {

  notifications:any;
  data: any;

  interactive_notifications:any = [
    'VOZ DEL EMPLEADO LEIDO',
    'VOZ DEL EMPLEADO ATENDIDO',
    'RECORDATORIO ENCUESTA',
    'ENCUESTA RECIBIDA',
    'RECONOCIMIENTO RECIBIDO',
    'RECORDATORIO MENSAJE',
    'MENSAJE RECIBIDO',
    'CARPETA CREADA',
    'DOCUMENTO SUBIDO',
    'TU RECIBO DE NOMINA YA ESTA DISPONIBLE',
    'DOCUMENTO BIENESTAR EN LINEA SUBIDO',
    'POLIZA DE SEGURO DISPONIBLE',
    'CARTA SUA'
  ]

  constructor(
    public modalController: ModalController,
    public pushService: PushService,
    private surveyService: SurveyService,
    private router: Router,
    private recognizeService: RecognizeService,
    private previewFile: PreviewAnyFile,
    private platform: Platform,
    private payrollAdvanceService: PayrollAdvanceService,
    private suaLetterService:SuaLetterService,
    private toastCtrl: ToastController 
  ) { }

  ngOnInit() {

    this.getNotifications();

  }
  closeModal() {
    this.eraseAll().then(()=>{
      this.modalController.dismiss();
    }).catch(err=>{
      console.log('err clean noti',err)
      this.modalController.dismiss();
    })
  }
  goPolice(item){

    this.pushService.notificationsMarkAs(item.id).subscribe(
      (data:any)=>{
        console.log("response leido", data);

        this.modalController.dismiss();
        let navigationExtras: NavigationExtras = {
          state: {
            message: item.data,
            modal:true
          }
        };
        this.router.navigate(['/assist-secure/dashboard-select'],navigationExtras)
      }
    );
  }

  openPayroll(notification) {
    this.pushService.notificationsMarkAs(notification.id).subscribe(_ => {
    /*  this.payrollAdvanceService.getReceipt(notification.data.id).subscribe(receipt => {
        //this.payrollAdvanceService.itemSelected(receipt);
          this.ShowPayslip(receipt);
      });*/
      this.ShowPayslip(notification.data.id);
    });
  }

  async ShowPayslip(payslip:any) {
    this.payrollAdvanceService.getReceipt(payslip).subscribe(
     async (receipt) => {
  
      this.data = receipt;
    console.log(this.data);
    if(this.data.signed == false){

      let modal = await this.modalController.create({
        component: PayslipFirmComponent,
        componentProps:{data: this.data},
      });
      modal.present();
     const { data } = await modal.onWillDismiss();
      console.log("response",data);
      if (data) {
        this.payrollAdvanceService.getReceipt(this.data.id).subscribe((res:any)=>{
          console.log('get pewrool update',res)
          this.payrollAdvanceService.presentAlertChooseType(res)
        },(err)=>console.log('err get payslip',err))
      }

    }else{
      this.payrollAdvanceService.presentAlertChooseType(this.data)
    }
    });
  }

  getNotifications() {
    this.pushService.getNotifications().subscribe((data: any) => {
      this.pushService.notifications = data.notifications;
      if (this.isLocalEnv() && (!this.pushService.notifications || this.pushService.notifications.length === 0)) {
        this.pushService.notifications = this.buildMockNotifications();
      }
    }, error => {
      if (this.isLocalEnv()) {
        this.pushService.notifications = this.buildMockNotifications();
      } else {
        this.closeModal();
      }
    });
  }

  private isLocalEnv(): boolean {
    return typeof environment.API_URL === 'string' && environment.API_URL.includes('localhost');
  }

  private buildMockNotifications(): any[] {
    return [
      {
        id: 'mock-1',
        type: 'MENSAJE RECIBIDO',
        status: 'NO LEIDA',
        date: 'Hoy - 9:32 AM',
        data: {
          sender: 'Recursos Humanos',
          date: 'Hoy - 9:32 AM',
          title: 'Nueva política de vacaciones 2026',
          body: '<p>Hola equipo, queremos compartir la actualización de nuestra política de vacaciones para este año. Revísala y confírmanos de enterado antes del 15 de mayo.</p>'
        }
      },
      {
        id: 'mock-2',
        type: 'TU RECIBO DE NOMINA YA ESTA DISPONIBLE',
        status: 'NO LEIDA',
        message: 'Tu recibo de nómina del 24 de abril ya está disponible.',
        date: 'Ayer - 6:05 PM',
        data: { id: 1234 }
      },
      {
        id: 'mock-3',
        type: 'RECONOCIMIENTO RECIBIDO',
        status: 'NO LEIDA',
        date: 'Ayer - 2:20 PM',
        data: {
          sender_name: 'María López',
          date: 'Ayer - 2:20 PM',
          acknowledgment_id: 99,
          id: 1
        }
      },
      {
        id: 'mock-4',
        type: 'ENCUESTA RECIBIDA',
        status: 'NO LEIDA',
        date: '2 de mayo - 11:00 AM',
        data: {
          sender: 'Cultura Paco',
          title: 'Encuesta de clima laboral Q2',
          description: 'Tu opinión nos ayuda a construir un mejor lugar para trabajar. Participa antes del 10 de mayo.',
          question_count: 12,
          shipping_id: 42
        }
      },
      {
        id: 'mock-5',
        type: 'CARTA SUA',
        status: 'NO LEIDA',
        message: 'Disponible para tu firma',
        date: '30 de abril - 4:48 PM',
        data: { bimester: 'Marzo - Abril 2026', signed: false }
      },
      {
        id: 'mock-6',
        type: 'POLIZA DE SEGURO DISPONIBLE',
        status: 'NO LEIDA',
        message: 'Tu póliza de gastos médicos ya está disponible para descargar.',
        date: '28 de abril - 10:12 AM',
        data: { policy_id: 'GMM-2026-001' }
      },
      {
        id: 'mock-7',
        type: 'VOZ DEL EMPLEADO ATENDIDO',
        status: 'NO LEIDA',
        date: '27 de abril - 9:00 AM',
        data: { subject: 'Cambio de horario', id: 7 }
      },
      {
        id: 'mock-8',
        type: 'CARPETA CREADA',
        status: 'NO LEIDA',
        message: 'Se creó una nueva carpeta de documentos para ti.',
        date: '25 de abril - 12:44 PM',
        data: { folder: { id: 1, name: 'Onboarding 2026' } }
      },
      {
        id: 'mock-9',
        type: 'DOCUMENTO SUBIDO',
        status: 'NO LEIDA',
        message: 'Se subió un nuevo documento a tu carpeta.',
        file_name: 'Constancia_situacion_fiscal.pdf',
        file_url: 'about:blank',
        date: '24 de abril - 5:30 PM'
      },
      {
        id: 'mock-10',
        type: 'RECORDATORIO ENCUESTA',
        status: 'NO LEIDA',
        message: 'Recuerda contestar tu encuesta pendiente.',
        date: '22 de abril - 8:00 AM',
        data: {
          title: 'Pulse semanal',
          description: 'Solo te tomará 2 minutos.',
          question_count: 4,
          shipping_id: 12
        }
      }
    ];
  }

  async viewEmployeeVoice(message){
    this.modalController.dismiss();
    
    this.pushService.notificationsMarkAs(message).subscribe(
      async (data:any)=>{
        console.log("response leido", data);

        let modal= await this.modalController.create({
          component:ViewEmployeeVoicePage,
          componentProps: {
            message: message.data
          }
        }); 
        modal.present();
      }
    );
  }

  goFolder(item){
    this.pushService.notificationsMarkAs(item.id).subscribe((data:any)=>{
      if(typeof item['data']['folder'] != 'undefined'){
        this.closeModal();
        let navigationExtras: NavigationExtras = {
          state: {
            folder: item['data']['folder']
          }
        };
        this.router.navigate(['/corp-docs/corp-subdocs'], navigationExtras);
      }
      if(typeof item['data']['subfolder'] != 'undefined'){
        this.closeModal();
        let navigationExtras: NavigationExtras = {
          state: {
            subfolder: item['data']['subfolder'],
            previous_folder: item['data']['subfolder']['folder']
          }
        };
        this.router.navigate(['/corp-docs/corp-subdocs-files'],navigationExtras);
      }
    });
  }

  goFile(item,index){
    this.pushService.notificationsMarkAs(item.id).subscribe((data:any)=>{
      this.openFile(item.file_url);
      this.pushService.notifications.splice(index,1);
    });
  }

  openFile(path) {
    if(this.platform.is('desktop') || this.platform.is('mobileweb')){
      window.open(path, '_system');
    } else {
      this.previewFile.preview(path)
        .then((res: any) => console.log(res))
        .catch((error: any) => console.error(error));
    }
  }

  async showRecognize(recognize,shipping){
    const modal= await this.modalController.create({
        component:ReceiveRecognizeComponent,
        componentProps: {
          'recognize': recognize,
          'shipping':shipping
        }
    });
    modal.onDidDismiss().then(data=>{
      console.log(data);
      if(data['data']['read']){
        this.showRecognizeDetail(shipping);  
      }
    })

    return await modal.present();
  }

    // Presenta el toast con el error
    async presentErrorToast(msg) {
      const toast = await this.toastCtrl.create({
        message: msg,
        duration: 3000,
        position: "bottom",
        color: "danger",
        cssClass: "toast",
      });
      toast.present();
    }

  async showRecognizeDetail(shipping){
    let modal= await this.modalController.create({
      component:RecognizeByPage,
      componentProps: {
        'shipping': shipping
      }
    });
    modal.present();
  }

  goMessage(item){

    this.pushService.notificationsMarkAs(item.id).subscribe(
      (data:any)=>{
        console.log("response leido", data);

        this.modalController.dismiss();
        let navigationExtras: NavigationExtras = {
          state: {
            message: item.data,
            modal:true
          }
        };
        this.router.navigate(['/message/mensaje'],navigationExtras)
      }
    );
  }

  goSurvey(item){
    let body = { 'survey_shippings_id' : item.data.shipping_id };
    this.surveyService.hasSurveys(body).subscribe((response_surveys:any)=>{
      if(response_surveys.status == 200){
        let count = response_surveys.data.count;
        if(count > 0){
          this.redirectToSurvey(item);
        }else{
          this.presentErrorToast("La encuesta no se encuentra disponible o ya fue respondida");
        }
      }
    });
  }

  redirectToSurvey(item){
    this.pushService.notificationsMarkAs(item.id).subscribe((data:any)=>{
      this.modalController.dismiss();
      let navigationExtras: NavigationExtras = {
        state: {
          survey: item.data,
        }
      };
      this.router.navigate(['survey/bienvenida'],navigationExtras);
      this.getNotifications();
    });
  }


  goRecognize(item){
    
    this.pushService.notificationsMarkAs(item.id).subscribe(
      async (data:any)=>{
        console.log("response leido", data);
        console.log("response recono", item.data.acknowledgment_id);

        await this.recognizeService.getRecognizeDetailData(item.data.acknowledgment_id).subscribe(
          (data:any)=>{
            console.log(data);
            if(data.status == 200){
              let acknowledgment = data.acknowledgment;
              let shippings = data.shippings;
    
              if(acknowledgment.count > acknowledgment.necessary_mentions){
                acknowledgment.count = acknowledgment.necessary_mentions;
              }
              
              let shipping = shippings.find(element => element.id == item.data.id);
    
              if(shipping){
                this.showRecognize(acknowledgment,shipping);
              }
    
            }else{
    
            }
          }
        );

      }
    );



  }

  async eraseAll(){

    let notifications_id:any =[];
    console.log('notifications',this.pushService.notifications)
    await this.pushService.notifications.forEach(element => {
      notifications_id.push(element.id);
    });

    // Local dev shortcut: si todas son mocks (IDs string 'mock-*'), no pegues al backend
    const allMocks = notifications_id.length > 0 && notifications_id.every((id: any) => typeof id === 'string' && id.indexOf('mock-') === 0);
    if (this.isLocalEnv() && allMocks) {
      this.pushService.notifications = [];
      return;
    }

    let data = {
      notifications_id:notifications_id,
      status:'LEIDA'
    }

    this.pushService.notificationsAllMarkAs(data).subscribe(
       (data:any)=>{
        console.log("response leido", data);

        if(data.status == 200){
          this.getNotifications();
        }
      },
      (err) => {
        console.log('err marcar notificaciones', err);
        this.presentErrorToast('No pudimos actualizar las notificaciones. Intenta de nuevo.');
      }
    );



  }
  async eraseOnlyNotiText(){

    let notifications_id:any =[];
    await this.pushService.notifications.forEach(element => {
      if(!this.interactive_notifications.includes(element.type))
      notifications_id.push(element.id);
    });
    let data = {
      notifications_id:notifications_id,
      status:'LEIDA'
    }
    if(notifications_id.length > 0)
    this.pushService.notificationsAllMarkAs(data).subscribe(
      async (data:any)=>{
        console.log("response leido", data);
      }
    );
  }
  goSuaLetter(item){
    this.pushService.notificationsMarkAs(item.id).subscribe(
      (data:any)=>{
        console.log("response leido", data);
        this.modalController.dismiss();
        this.suaLetterService.ShowSuaLetter(item.data)
        this.getNotifications();
      }
    );
  }

}
